module.exports = __webpack_public_path__ + "img/overdue_icon.af31d640.png";